// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"e56e1775","404":"071deebf","556":"4b0240cb","881":"a42c728a"}[chunkId] + ".chunk.js";
};